var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 11.932203,7.6006102 5.457627,4.9118648 v 8.524813 H 15.20678 V 14.488136 H 8.6576272 v 6.549152 H 6.4745763 V 12.512475 L 11.932203,7.6006102 m 0,-2.9362034 -10.9152538,9.8237292 h 3.2745763 v 8.732203 h 6.5491525 v -6.549153 h 2.183051 v 6.549153 h 6.549152 v -8.732203 h 3.274576 z",
    style: {
      strokeWidth: 1.09152544
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDashboard);
export default __webpack_public_path__ + "static/media/navDashboard.5ffde053cd1b32d1a8f8a1c5d1395209.svg";
export { ForwardRef as ReactComponent };